/** Undo stack limits for the drawing history slice. */
export const UndoHistory = {
	/** Oldest snapshots are dropped once the stack grows past this. */
	maxEntries: 12,
} as const;
